import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ua, generateDeepLink } from '@mssgme/helpers';
import { __t } from '@mssgme/shared';
import { CardMessengers } from '../CardMessengers';
import { MessengerButton } from '../MessengerButton';

import styles from './styles.scss';

const excerptLength = 90;
const getExcerpt = (string) => (string.length > excerptLength ? `${string.slice(0, excerptLength)}...` : string);

export class CardMessengersPane extends Component {
    static propTypes = {
        photo: PropTypes.string,
        fullName: PropTypes.string,
        category: PropTypes.string,
        messengers: PropTypes.array,
        animated: PropTypes.bool,
        description: PropTypes.string,
    };

    constructor(props) {
        super(props);
        const { description } = this.props;

        this.state = {
            excerpt: description.length > excerptLength,
        };
    }

    toggleDescription = () => {
        this.setState({
            excerpt: !this.state.excerpt,
        });
    };

    render() {
        const { photo, fullName, category, messengers, animated, description } = this.props;
        const mesProps = messengers.map((m) => ({
            platform: m.messenger,
            href: ua.isMobile ? generateDeepLink(m).getUrl() : m.redirectUrl,
        }));

        return (
            <div className={classNames(styles.root, styles.slideDown, animated ? styles.animated : null)}>
                <div className={styles.userInfoContainer}>
                    <div className={styles.userPhoto}>
                        <img src={photo} alt={fullName} />
                    </div>
                    <div className={styles.userNameCategory}>
                        <div>
                            <h1>{fullName}</h1>
                            {/* {category !== 'category_not_business' && <p>{__t(category)}</p>} */}
                        </div>
                    </div>
                </div>
                {description && (
                    <div className={styles.description} onClick={this.toggleDescription}>
                        <p>{description}</p>
                    </div>
                )}
                {messengers.length > 0 && (
                    <CardMessengers>
                        {mesProps.map((props) => (
                            <MessengerButton key={props.platform} data-messenger={props.platform} {...props} />
                        ))}
                    </CardMessengers>
                )}
            </div>
        );
    }
}
